import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { takeUntil, Subject, Observable } from 'rxjs';
import { CurrentStateService } from '../../core/services/current-state.service';
import { ControlPoint } from '../../shared/models/controlPoint';
import { Site } from '../../shared/models/site';
import { PopupCloseMode, PopupOpenMode } from '../control-points/models/popupMode';
import { SlideMenuEventComponent } from '../vibration-events/components/slide-menu-event/slide-menu-event.component';
import { SlideMenuControlPointsComponent } from '../control-points/components/slide-menu-control-points/slide-menu-control-points.component';
import { MENU_OPTIONS } from '../../shared/constants/left-menu-option'
import { EventData } from '../vibration-events/models/event-data';
import { TranslateModule } from '@ngx-translate/core';
import { SeismographDevicesComponent } from '../seismograph-devices/components/seismograph-devices-modal/seismograph-devices-modal.component';


@Component({
  selector: 'app-slide-menu',
  imports: [CommonModule, SlideMenuEventComponent, SlideMenuControlPointsComponent, SeismographDevicesComponent, TranslateModule,],
  templateUrl: './slide-menu.component.html',
  styleUrl: './slide-menu.component.scss'
})
export class SlideMenuComponent implements OnInit, OnDestroy {
  @Input() toggle: boolean = false;
  @Input() currentSite: Site | undefined;
  @Input() popupContainer!: ViewContainerRef;

  private unsubscribe$ = new Subject<void>();
  private innerWidth: number | undefined;
  protected controlPoints: ControlPoint[] = [];
  protected toggleSubMenu: boolean = false;
  protected menuVisible = false;
  protected btnCreateIsDisabled: boolean = false;
  protected lastSelectedCpIndex: number = -1;

  currentMenu$: Observable<string | null> | undefined;
  menuOptions = MENU_OPTIONS;

  @Input() allEvents!: EventData[];


  constructor(
    protected currentStateService: CurrentStateService,
  ) {
    this.currentMenu$ = this.currentStateService.currentMenu$;
  }

  ngOnInit() {

    this.innerWidth = window.innerWidth;
    this.currentStateService.currentControlPoint$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (controlPoint: ControlPoint | null) => {
        if (controlPoint) {
          const index = this.controlPoints.findIndex(x => x.controlPointId === controlPoint.controlPointId);
          this.openCloseMenu(index);
        }
      }
    });

    // is trigger when popup is close
    this.currentStateService.closePopup$.pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (closeMode: PopupCloseMode | null) => {
        if (closeMode === PopupCloseMode.CREATED) {
          this.lastSelectedCpIndex = this.controlPoints.length - 1;
        }
        this.btnCreateIsDisabled = false;
      }
    });

    this.currentStateService.slideMenu$.subscribe({
      next: (isClose: boolean) => {
        this.menuVisible = isClose;
        this.closeAll();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  protected toggleMenu() {
    this.menuVisible = !this.menuVisible;
    this.closeAll();
  }

  private closeAll() {
    if (!this.menuVisible) {
      this.lastSelectedCpIndex = -1;
      this.toggleSubMenu = false;
      this.currentStateService.setClosePopup(PopupCloseMode.CLOSE);
      this.currentStateService.setCurrentControlPoint(null);
    }
  }

  protected openPopupCreate() {
    this.btnCreateIsDisabled = true;
    this.toggleSubMenu = false;
    this.lastSelectedCpIndex = -1;
    this.currentStateService.setOpenPopup(PopupOpenMode.CREATE);
  }

  protected openPopupEditPosition() {
    this.btnCreateIsDisabled = true;
    this.currentStateService.setOpenPopup(PopupOpenMode.EDIT);
  }

  protected selectControlPoint(controlPoint: ControlPoint, selectedIndex: number) {
    this.currentStateService.setClosePopup(PopupCloseMode.CLOSE);
    this.currentStateService.setCurrentControlPoint(controlPoint);

    if (this.innerWidth && this.innerWidth < 768) {
      this.menuVisible = false;
    }
  }

  protected openCloseMenu(controlPointIndex: number) {
    if (this.lastSelectedCpIndex == controlPointIndex) {
      this.lastSelectedCpIndex = -1;
      this.toggleSubMenu = false;
    } else {
      this.lastSelectedCpIndex = controlPointIndex;

      if (!this.menuVisible) {
        this.menuVisible = true;
      }

      this.toggleSubMenu = true;
    }
  }
}


